<div
  *ngIf="isDrawing && doesSignFieldHaveMinPossibleSize"
  class="app-sign-field-point"
  [style.left.pt]="drawingStartPoint.x - SIGN_FIELD_POINT_WIDTH_PX / 2"
  [style.top.pt]="drawingStartPoint.y - SIGN_FIELD_POINT_HEIGHT_PX / 2"
  [style.width.pt]="SIGN_FIELD_POINT_WIDTH_PX"
  [style.height.pt]="SIGN_FIELD_POINT_HEIGHT_PX"
></div>

<lib-document-field
  *ngIf="isDrawing && doesSignFieldHaveMinPossibleSize"
  class="app-canvas-sign-field"
  [boundingBox]="{ topLeft: topLeft, bottomRight: bottomRight } | boundingBox"
>
  <lib-signature-field [style.opacity]="!doesSignFieldHaveMinAllowedSize ? 0.4 : 1">
    <div *ngIf="!doesSignFieldHaveMinAllowedSize" class="app-sign-field-info nowrap col" header>
      {{ 'DOCUMENT_EDITOR.MIN_SIGN_FIELD_SIZE_NOT_REACHED' | translate }}
    </div>
  </lib-signature-field>
</lib-document-field>
